import React, {FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Alert} from 'reactstrap';

import Selectors from "~/state/selectors.ts";
import useEffectOnce from "~/hooks/use-effect-once.ts";
import {actions} from "~/state/reducers/codes-reducer.ts";

function withOneCode<P>(WrappedComponent: React.ComponentType<P>) {
    const WithOneCodeComponent: FC<P> = (props) => {
        const dispatch = useDispatch();
        const metaCodes = useSelector(Selectors.getMetaCodes);
        const commonWorktags = useSelector(Selectors.getCurrentCommonWorktags);

        useEffectOnce(() => {
            if (props.params.codeId) {
                if (metaCodes?.fetchingCurrentCode !== true) {
                    dispatch(actions.loadOneCode(props.params.codeId))
                }
            } else {
                dispatch(actions.currentCodeReset(commonWorktags));
            }
        });

        return (
            <>
                {metaCodes?.loadedCurrentCode ? <WrappedComponent {...props}/> :
                    <Alert className="m-4" color="info">Loading...</Alert>}
            </>
        );
    }

    return WithOneCodeComponent;
}

export default withOneCode;
